<template>
  <div class="page_content wheel_spin prize">

    <div class="main_section">
      <div class="container prizes_wheel">
        <div class="row justify-content-center top_title">
          <div class="col-12 text-center">
            <h1>Gefeliciteerd!</h1>
          </div>
          <div class="col-12">
            <div class="d-flex flex-column flex-md-row flex-lg-row justify-content-center align-items-center my-0 my-lg-5 my-md-5">
              <div class="d-flex flex-column text-center align-items-center w-100 w-lg-50 w-md-50">
                <h2 class="w-100 w-lg-50 w-md-50 text-center text-lg-left text-md-left ml-auto">
                  Geweldig, je hebt een<br> hoofdprijs gewonnen!</h2>
                <h3 class="w-100 w-lg-50 w-md-50 text-center text-lg-left text-md-left mt-4 ml-auto">
                  Vul op de volgende pagina<br> je adres gegevens in.</h3>
                <div class="button_container_for_left"><button type="button" @click="goToDeliveryDetails()" class="black_btn claim_prize_left"><div class="black_btn_contain"><p>Claim je prijs</p></div></button></div>
              </div>
              <div class="d-flex flex-column text-center align-items-center w-100 w-lg-50 w-md-50 wheel_prize_box">
                <div class="inside_container">
                  <p>{{ getPhysicalDisplayedPrize.name }}</p>
                  <img :src="getPhysicalDisplayedPrize.image" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import router from '../router'
  import gameFlow from "../common/mixin/gameFlow";

  export default {
    name: 'PhysicalPrize',
    mixins:[
      gameFlow
    ],
    computed: {
      ...mapGetters([
        'getGameResponse',
        'getPhysicalPrize',
        'getPhysicalDisplayedPrize',
        'getExtraChance',
        'getTelcoValidRewardIds',
        'getSelectedCodeForRedemption'
      ])
    },
    mounted() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.updatePhysicalPrize(this.getGameResponse.reservedRewards[1])
      if (this.getGameResponse.displayedReward !== undefined) {
        this.updatePhysicalDisplayedPrize(this.getGameResponse.displayedReward)
      }

      if (!this.getExtraChance) {
        this.networkRewardInfo(this.getTelcoValidRewardIds, this.getSelectedCodeForRedemption)
          .then((response) => {
            this.$store.commit('updateTelcoInfo', response.data.customNetworkInfoApiList)
          })
      }
      this.setInGameFlow("true", this.$route.path.substring(1))
    },
    methods: {
      ...mapMutations([
        'updatePhysicalPrize',
        'updatePhysicalDisplayedPrize',
        'updateTelcoInfo',
        'updateTelcoValidRewardIds'
      ]),
      ...mapActions([
        'networkRewardInfo'
      ]),
      goToDeliveryDetails() {
        router.push({name: 'DeliveryDetails'})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PhysicalPrize.vue